module.exports = __webpack_public_path__ + "img/2023-28.be77e6cd.jpg";